import Swal from 'sweetalert2';

const langRu = {
  errorLoading: function () {
    return 'Невозможно загрузить результаты';
  },
  loadingMore: function () {
    return 'Загрузка данных…';
  },
  noResults: function () {
    return 'Совпадений не найдено';
  },
  searching: function () {
    return 'Поиск…';
  },
  removeAllItems: function () {
    return 'Удалить все элементы';
  },
  inputTooShort: function () {
    return 'Введите больше символов для начала поиска';
  },
};

const select2SettingsMixin = {
  language: langRu,
  allowClear: true,
  matcher: function (params: { term: string }, data: { text: string }) {
    if (!params.term) return data;
    if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) return data;
    else return null;
  },
  minimumResultsForSearch: 5,
};

export const DATE_FORMATS = {
  YYYY: 'YYYY', // 2023
  DD_MMMM: 'DD MMMM', // 23 Января
  'MM.YYYY': 'MM.YYYY', // 10.2023
  'MMM, YYYY': 'MMM, YYYY', // Янв, 2023
  MMMM_YYYY: 'MMMM YYYY', // Января (или Январь) 2023
  'DD.MM.YYYY': 'DD.MM.YYYY', // 23.10.2023
  'YYYY-MM-DD': 'YYYY-MM-DD', // 2023-10-23
  'YYYY-MM': 'YYYY-MM', // 2023-10
  'DD-MM-YYYY': 'DD-MM-YYYY', // 2023-10-23
  YYYYMMDD: 'YYYYMMDD', // 20231023
  DD_MMMM_YYYY: 'D MMMM YYYY', // 23 Января 2023
  'D MMMM YYYY HH:mm': 'D MMMM YYYY HH:mm', // 23 Января 2023 01:10
  YYYY_MM_DD_SLASH: 'YYYY/MM/DD', // 2023/12/23
  'DD.MM.YYYY HH:mm': 'DD.MM.YYYY HH:mm', // 23.12.2023 01:10
  'DD.MM.yyyy HH:mm:ss': 'DD.MM.yyyy HH:mm:ss', // 23.12.2023 01:10:21
  'HH:mm': 'HH:mm', // 23:12
} as const;

export default {
  langRu,
  emptySelectOptionText: '-- не выбрано --',
  validatorMessageEmpty: 'Введите данные',
  pageSize: 10,
  bigPageSize: 20,
  messengerFileLimit: 5,
  messengerFileMaxSize: 10485760,
  confirmOptions: {
    /** @type {import('sweetalert2').SweetAlertOptions} */
    delete: {
      title: 'Удаление',
      text: 'Вы действительно хотите удалить эту запись?',
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      showCancelButton: true,
      icon: 'warning',
    },
    changeStatus: {
      title: 'Изменение статуса',
      text: 'Изменить статус этой записи?',
      confirmButtonText: 'Изменить',
      cancelButtonText: 'Отмена',
      showCancelButton: true,
      icon: 'warning',
    },
    decline: {
      title: 'Отклонение участника',
      text: 'Вы действительно хотите отклонить этого участника?',
      confirmButtonText: 'Отклонить',
      cancelButtonText: 'Отмена',
      showCancelButton: true,
      icon: 'warning',
    },
  },

  countryRussiaId: 235,
  countryRussiaName: 'РОССИЯ',
  countryCubaId: 119,
  countryDPRKId: 171,
  countryKNR: 108,
  countryGroupEAEC: 7,
  eapAssignemntStatusDoneId: 4,
  errorTitle: 'Ошибка',
  validationError: 'Проверьте правильность заполнения полей.',
  commonError: 'Произошла ошибка. Обратитесь в техническую поддержку.',
  commonSuccess: 'Данные успешно сохранены.',
  errorDownloadFile: 'Формат файла некорректный',
  tooltipLegendCommon: 'Для выбора отображаемых показателей на диаграмме нажмите на соответствующий элемент легенды',
  select2Settings: select2SettingsMixin,
  select2SettingsSearchAll: {
    language: langRu,
    allowClear: true,
  },
  select2SettingsMultiple: Object.assign({ multiple: true, closeOnSelect: false }, select2SettingsMixin),
  select2SettingsNoClear: {
    language: langRu,
    allowClear: false,
  },
  select2SettingsNoSearch: {
    language: langRu,
    allowClear: true,
    minimumResultsForSearch: Infinity,
  },
  yesNoList: [
    {
      id: null,
      text: 'Не выбрано',
    },
    {
      id: true,
      text: 'Да',
    },
    {
      id: false,
      text: 'Нет',
    },
  ],
  chatType: {
    private: 1,
    group: 2,
    room: 3,
    techSupport: 4,
  },
  entityStatus: {
    draft: 1,
    published: 2,
    archive: 3,
    onApproval: 4,
  },
  entityType: {
    employee: 8,
    news: 11,
  },
  organizationType: {
    foiv: 1, // ФОИВ
    navigatorParticipant: 2, // Участник ВЭД
    external: 3, // Внешний пользователь
    regionalOrInternational: 4, // Региональная/международная организация
    subjectRF: 5, // Субъект РФ
  },
  tradingOperation: {
    export: 1,
    import: 2,
  },
  userType: {
    internal: 1,
    external: 2,
  },
  tradeItemType: {
    tnved: 1,
    okved: 2,
  },
  proposalRequestType: {
    participantsPlenarySession: 1,
    participantsNarrowCircle: 2,
    suggestionsForAgenda: 3,
    suggestionsForProtocol: 4,
  },
  eventRequestStatus: {
    new: 1,
    answerExpected: 2,
    answerReceived: 3,
    overdue: 4,
  },
  moderationtStatus: {
    new: 1,
    review: 2,
    accepted: 3,
    rejected: 4,
  },
  fileType: {
    photo: 1,
    video: 2,
    other: 3,
  },
  newsType: {
    mpkNews: 1,
    review: 2,
    measureInfo: 3,
  },
  organizationMinekId: 1,

  alert: Swal.mixin({
    //customClass: {
    //  confirmButton: 'btn btn-success',
    //  cancelButton: 'btn btn-danger'
    //},
    //buttonsStyling: false
  }),

  Permissions: {
    AdminAccess: 5,

    RoleCreate: 6,
    RoleView: 7,
    RoleEdit: 8,
    RoleDelete: 9,

    UserView: 11,
    UserEdit: 12,

    EmployeeView: 25,

    OrgCreate: 32,
    OrgView: 33,
    OrgEdit: 34,
    OrgDelete: 35,

    DeptCreate: 50,
    DeptView: 51,
    DeptEdit: 52,
    DeptDelete: 53,

    PermissionMatrixView: 113,
    PermissionMatrixEdit: 114,

    UserNotificationEdit: 140,
    UserNotificationView: 4922,
    NotificationTextEdit: 141,
    NotificationTextView: 6040,
    NotificationTextApprove: 6041,

    ContactsView: 4921,
    AddressBookView: 4923,

    SettingsEdit: 200,
    SettingsView: 202,
    MpkProjectsAccess: 152,
    MpkProjectEdit: 153,
    MpkProjectFoivReview: 155,
    MpkProjectCreateEap: 1531,
    MpkProjectCreate: 1534,
    MpkProjectDelete: 1535,

    MpkCommissionAccess: 160,
    MpkCommissionEdit: 161,
    MpkCommissionCreate: 1610,
    MpkCommissionDelete: 1611,
    AccountCochairAccess: 162,
    MpkBarrierQuestionsEdit: 106,

    MpkPodgotovkaAccess: 17,
    MpkEventsAccess: 170,
    MpkEventsEdit: 171,
    MpkEventsTimelineEdit: 1710,
    MpkTaskAccess: 172,
    MpkTaskEdit: 173,
    MpkLibraryAccess: 174,
    MpkLibraryEdit: 175,
    MpkRequestsAccess: 176,
    MpkRequestsEdit: 177,
    MpkAssignmentAccess: 178,
    MpkAssignmentEdit: 179,
    MpkAssignmentViewAllFoiv: 1790,
    MpkAssignmentCreate: 1791,
    MpkAssignmentDelete: 1792,

    EapTaskAccess: 180,
    EapTaskEdit: 181,
    EapTaskViewAllStatus: 1810,
    EapAssignmentAccess: 182,
    EapAssignmentEdit: 183,
    EapAssignmentCreate: 1831,
    EapAssignmentDelete: 1832,

    NewsAccess: 21,
    NewsEdit: 210,
    NewsPublish: 2114,
    NewsCreate: 2120,
    NewsDelete: 2121,
    NewsExport: 2122,
    NewsApprove: 2123,
    NewsRefuse: 2124,
    NewsSubscriptionUserAccess: 2140,
    NewsSubscriptionUserEdit: 2141,
    NewsSubscriptionSend: 2142,
    NewsSubscriptionUserApprove: 2143,
    NewsSubscriptionUserRefuse: 2144,
    NewsSubscriptionUserView: 2145,
    MassMediaAccess: 2150,
    MassMediaEdit: 2151,
    MassMediaCreate: 2152,
    MassMediaDelete: 2153,

    NsiAccess: 23,
    NsiEdit: 211,
    NsiCreate: 231,
    NsiDelete: 232,
    NsiExport: 233,
    CountryView: 353,
    CountryEdit: 354,
    CountryCreate: 3540,
    CountryDelete: 3541,

    ScenarioCreate: 401,
    ScenarioView: 402,
    ScenarioEdit: 403,
    ScenarioDelete: 404,

    MeasureSingleTtrCreate: 471,
    MeasureSingleTtrView: 472,
    MeasureSingleTtrEdit: 473,
    MeasureSingleTtrDelete: 474,
    MeasureSingleTtrExport: 4951,

    MeasureUnilateralNonTrCreate: 475,
    MeasureUnilateralNonTrView: 476,
    MeasureUnilateralNonTrEdit: 477,
    MeasureUnilateralNonTrDelete: 478,
    MeasureUnilateralNonTrExport: 4952,

    RequestInitiativeTtrCreate: 479,
    RequestInitiativeTtrView: 480,
    RequestInitiativeTtrChangeStatus: 481,
    RequestInitiativeTtrAddComment: 482,
    RequestInitiativeTtrAddTimeline: 491,
    RequestInitiativeTtrEditTimeline: 492,
    RequestInitiativeTtrDeleteTimeline: 493,
    RequestInitiativeTtrCreateAdmin: 494,
    RequestInitiativeTtrEditRate: 496,
    RequestInitiativeTtrDeleteRate: 497,
    RequestInitiativeTtrDeleteComment: 498,
    RequestInitiativeTtrExport: 499,

    MeasureMarketDefenceCreate: 483,
    MeasureMarketDefenceView: 484,
    MeasureMarketDefenceEdit: 485,
    MeasureMarketDefenceDelete: 486,
    MeasureMarketDefenceExport: 4953,

    EecInvestigationCreate: 487,
    EecInvestigationView: 488,
    EecInvestigationEdit: 489,
    EecInvestigationDelete: 490,

    RestrictionMeasureAccess: 500,
    RestrictionMeasureCreate: 501,
    RestrictionMeasureView: 502,
    RestrictionMeasureEdit: 503,
    RestrictionMeasureDelete: 504,
    RestrictionMeasureApprove: 505,

    // Загрузка аналитических материалов
    AnalyticsImportView: 550,

    BankRateView: 672,
    BankRateImport: 670,

    BudgetPolicyView: 612,
    BudgetPolicyImport: 615,

    CitizensView: 5503,
    CitizensInRussiaView: 597,
    CitizensInRussiaImport: 600,
    CitizensOutRussiaView: 592,
    CitizensOutRussiaImport: 595,

    CountryCreditRatingView: 5508,
    CountryCreditRatingImport: 1044,

    CountryMappingView: 5507,
    CountryMappingCreate: 1031,

    CountryRatingView: 562,
    CountryRatingImport: 565,

    ExportProductView: 567,
    ExportProductImport: 570,

    ExportPotentialView: 552,
    ExportPotentialEdit: 553,
    ExportPotentialImport: 555,
    ExportPotentialExport: 4601,

    ExportPotentialServicesView: 5501,
    ExportPotentialServicesImport: 5536,
    ExportPotentialServicesCreate: 5537,
    ExportPotentialServicesEdit: 5538,
    ExportPotentialServicesDelete: 5539,

    FavorTradeView: 5509,
    FavorTradeImport: 1054,

    FinancialSectorView: 5504,
    FinancialSectorImport: 5517,

    ForeignInvestmentView: 5525,
    ForeignInvestmentImport: 5518,

    ForeignTradeView: 617,
    ForeignTradeImport: 620,

    ForeignTradeTurnoverWorldView: 662,
    ForeignTradeTurnoverWorldImport: 660,

    FtsView: 572,
    FtsImport: 575,

    GreenEconomyView: 5502,
    GreenEconomyByFuelView: 577,
    GreenEconomyByFuelImport: 580,
    GreenEconomyByFuelExport: 5512,
    GreenEconomyCo2View: 582,
    GreenEconomyCo2Import: 585,

    HealthcareView: 5505,
    HealthcareImport: 5532,
    HealthcareCreate: 5533,
    HealthcareEdit: 5534,
    HealthcareDelete: 5535,

    ImportPotentialView: 4701,
    ImportPotentialImport: 4703,
    ImportPotentialEdit: 4702,
    ImportPotentialExport: 4704,

    IndicatorLoadMonitoringView: 5529,
    IndicatorLoadMonitoringExport: 5531,

    InflationView: 5506,
    InflationImport: 5544,

    InternationalInvestmentPositionView: 657,
    InternationalInvestmentPositionImport: 655,

    InvestmentView: 587,
    InvestmentImport: 590,

    InvestmentRussiaView: 642,
    InvestmentRussiaImport: 640,

    KeyCountryIndicatorView: 5511,
    KeyCountryIndicatorCreate: 5519,
    KeyCountryIndicatorUpdate: 5520,
    KeyCountryIndicatorDelete: 5521,

    KeyIndicatorsView: 5545,

    LifeIndexView: 637,
    LifeIndexImport: 635,

    MacroeconomicIndicatorView: 5514,
    MacroeconomicIndicatorExport: 5523,
    MacroeconomicIndicatorCountryValueCreate: 556,
    MacroeconomicIndicatorCountryValueView: 557,
    MacroeconomicIndicatorCountryValueEdit: 558,
    MacroeconomicIndicatorCountryValueDelete: 559,
    MacroeconomicIndicatorCountryValueImport: 560,

    PriorityDestinationImportView: 681,
    PriorityDestinationImportImport: 684,

    RealDisposablePersonalIncomeView: 652,
    RealDisposablePersonalIncomeImport: 650,

    StriIndexImport: 665,

    TecWorldView: 622,
    TecWorldImport: 625,

    TradeEconomicRelRussiaView: 627,
    TradeEconomicRelRussiaImport: 630,

    UnfriendlyCountryStatusView: 5510,
    UnfriendlyCountryStatusImport: 1055,

    MpkEventRequestCreate: 701,
    MpkEventRequestEdit: 703,
    MpkEventRequestChangeStatus: 704,
    MpkEventRequestAnswerProposalCreate: 706,
    MpkEventRequestAnswerProposalEdit: 708,
    MpkEventRequestAnswerProposalChangeStatus: 709,

    FreeTradeAgreement: 800,

    WidgetOnMainForAllCountry: 810,

    WidgetView: 6001,
    WidgetEdit: 6002,

    FormulaEdit: 4902,
    FormulaView: 4907,

    FilterView: 4903,
    FilterEdit: 4904,
    FilterDelete: 4905,

    OrganizationsRefresh: 4906,

    AuditPageView: 6010,
    AuditPageDelete: 6011,
    AuditPageExport: 6012,

    MenuView: 6020,
    MenuEdit: 6021,

    IndicatorVisibilityEdit: 6030,

    AuditPortalStatisticView: 6050,
    AuditPortalStatisticExport: 6052,

    AuditPublicStatisticView: 6051,
    AuditPublicStatisticExport: 6053,

    CountryAnalyticsMacroEcon: 1901,
    CountryAnalyticsIntegrationIndicators: 1902,
    CountryAnalyticsCountryRating: 1903,
    CountryAnalyticsLifeIndex: 1904,
    CountryAnalyticsBudgetPolicy: 1905,
    CountryAnalyticsMonetaryPolicy: 1906,
    CountryAnalyticsFinancialSector: 1907,
    CountryAnalyticsForeignTrade: 1908,
    CountryAnalyticsInvestments: 1909,
    CountryAnalyticsGreenEconomics: 1910,
    CountryAnalyticsHealth: 1911,
    CountryAnalyticsAdditionalInfo: 1912,
    CountryAnalyticsRussiaForeignTrade: 1913,
    CountryAnalyticsRussiaAccess: 1914,
    CountryAnalyticsRussiaInvestments: 1915,
    CountryAnalyticsRussiaJointProjects: 1916,
    CountryAnalyticsRussiaInsitutionalForms: 1917,
    CountryAnalyticsEconomicsReview: 1918,
    CountryAnalyticsEconomicsRussia: 1919,
    CountryAnalyticsReferenceInfo: 3000,
    CountryAnalyticsReferenceInfoListFiles: 3100,
    CountryAnalyticsReferenceInfoHiddenListFiles: 3101,
    CountryAnalyticsReferenceInfoChangingName: 3102,
    CountryAnalyticsReferenceInfoMovingToArchive: 3103,
    CountryAnalyticsReferenceInfoAdditionFile: 3104,
    CountryAnalyticsReferenceInfoChangingVisibility: 3105,
    CountryAnalyticsReferenceInfoArchive: 3200,
    CountryAnalyticsReferenceInfoReadArchive: 3201,
    CountryAnalyticsReferenceInfoRecoveryArchive: 3202,
    CountryAnalyticsReferenceInfoRemovingArchive: 3203,
    CountryAnalyticsReferenceInfoHistory: 3300,
    CountryAnalyticsReferenceInfoReadHistory: 3301,

    AccessCrossCuttingTask: 102,
    AccessToCreatingCrossCuttingTask: 1021,
    CrossCuttingTaskCreate: 1021,
    AccessToEditingSubtaskCrossCuttingTask: 1022,
    CrossCuttingTaskEdit: 1022,
    AccessToCreatingRequestCrossCuttingTask: 1023,

    AccessEditableResponsibleEmployee: 1400,

    // Аналитика внешней торговли
    ForeignTradeAnalyticsView: 804,

    ForeignTradeAnalyticsWorldByRegionsView: 3401,
    ForeignTradeAnalyticsWorldByRegionsBuild: 3402,
    ForeignTradeAnalyticsWorldByRegionsDownload: 3403,

    ForeignTradeAnalyticsRegionByProductsView: 3501,
    ForeignTradeAnalyticsRegionByProductsBuild: 3502,
    ForeignTradeAnalyticsRegionByProductsDownload: 3503,

    ForeignTradeAnalyticsRegionsByCountriesView: 3601,
    ForeignTradeAnalyticsRegionsByCountriesBuild: 3602,
    ForeignTradeAnalyticsRegionsByCountriesDownload: 3603,

    ForeignTradeAnalyticsAggregatedByRegionsView: 3701,
    ForeignTradeAnalyticsAggregatedByRegionsBuild: 3702,
    ForeignTradeAnalyticsAggregatedByRegionsDownload: 3703,

    ForeignTradeAnalyticsAggregatedByProductsView: 3801,
    ForeignTradeAnalyticsAggregatedByProductsBuild: 3802,
    ForeignTradeAnalyticsAggregatedByProductsDownload: 3803,

    ForeignTradeAnalyticsRussiaWorldYearlyNoteView: 3901,
    ForeignTradeAnalyticsRussiaWorldYearlyNoteBuild: 3902,
    ForeignTradeAnalyticsRussiaWorldYearlyNoteDownload: 3903,

    ForeignTradeAnalyticsWorldMonthlyNoteView: 4001,
    ForeignTradeAnalyticsWorldMonthlyNoteBuild: 4002,
    ForeignTradeAnalyticsWorldMonthlyNoteDownload: 4003,

    ForeignTradeAnalyticsFtsMonthRequestView: 4101,
    ForeignTradeAnalyticsFtsMonthRequestBuild: 4102,
    ForeignTradeAnalyticsFtsMonthRequestDownload: 4103,

    ForeignTradeAnalyticsFtsWeekRequestView: 4201,
    ForeignTradeAnalyticsFtsWeekRequestBuild: 4202,
    ForeignTradeAnalyticsFtsWeekRequestDownload: 4203,

    ForeignTradeAnalyticsGasRecalculationUpload: 4301,
    ForeignTradeAnalyticsWeeklyDataUpload: 4401,
    ForeignTradeAnalyticsDbfLoaderUpload: 4501,

    ForeignTradeAnalyticsNsiLoaderUpload: 4901,

    VedAdditionalUploadingView: 4511,
    VedAdditionalGasUploadingView: 4512,
  },

  USER_ROLE_ID: {
    /** Роль сотрудника загранаппарата */
    foreignEmployeeRole: 6,
    /** Роль Администратор модуля ВЭС */
    moduleAdministratorVES: 1411,
    /** Роль субьект РФ */
    subjectRF: 1410,
    /** Роль сотрудника ВЭД */
    employeeVED: 1419,
  },

  userRoleIds: {
    // id роли "субъект РФ"
    subjectRF: 1410,
  },

  monthList: [
    { id: 1, text: 'Январь' },
    { id: 2, text: 'Февраль' },
    { id: 3, text: 'Март' },
    { id: 4, text: 'Апрель' },
    { id: 5, text: 'Май' },
    { id: 6, text: 'Июнь' },
    { id: 7, text: 'Июль' },
    { id: 8, text: 'Август' },
    { id: 9, text: 'Сентябрь' },
    { id: 10, text: 'Октябрь' },
    { id: 11, text: 'Ноябрь' },
    { id: 12, text: 'Декабрь' },
  ],
  monthListSimple: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  monthListGenitive: [
    'январе',
    'феврале',
    'марте',
    'апреле',
    'мае',
    'июне',
    'июле',
    'августе',
    'сентябре',
    'октябре',
    'ноябре',
    'декабре',
  ],
  finSectorNumbering: {
    0: '',
    1: 'тыс.',
    2: 'млн.',
    3: 'млрд.',
    4: 'трлн.',
    5: 'квдлн.',
  },
  CrosscuttingSubtaskStatus: {
    NOT_COMPLETED: 1,
    WORK: 2,
    COMPLETED: 3,
  },
  DATE_FORMATS,

  MILLION: 1000000,
  THOUSAND: 1000,

  FILE_MAX_SIZE_2MB: 2097152,
  FILE_MAX_SIZE_20MB: 20971520,

  MIN_INT_32: -2147483648,

  MODAL_INFO_ICON: {
    ACCEPT: 'acceptIcon',
    ERROR: 'errorIcon',
  },

  statusOptions: [
    {
      id: 1,
      text: 'Действующий',
    },
    {
      id: 2,
      text: 'Не действующий',
    },
  ],

  statusOptionsIDs: {
    active: '1',
    notActive: '2',
  },

  paramsFullListDefault: {
    pageNumber: 1,
    pageSize: 0,
    isActive: true,
  },

  governmentTypes: [
    { id: 1, text: 'СССР' },
    { id: 2, text: 'РФ' },
  ],

  sort: {
    ascending: 'ascending',
    descending: 'descending',
    default: 'default',
  },

  sortOrder: {
    ascending: 0,
    descending: 1,
  },

  optionsDescendingAscending: [
    {
      id: 0,
      text: 'По убыванию',
    },
    {
      id: 1,
      text: 'По возрастанию',
    },
  ],

  dateLowerLimit: new Date(1900, 0, 1),
  dateUpperLimit: new Date(2099, 0, 1),

  indicator: {
    placeInMarket: {
      EXPORT: 'placeInRussianExports',
      IMPORT: 'placeInRussianImports',
      TRADE_TURNOVER: 'placeInRussianTradeTurnover',
      EXPORT_NON_ENERGY_VALUE: 'placeInRussianExportNonEnergy',
      BALANCE: 'placeInRussianBalance',
    },
    previousPercentValue: {
      TOTAL_VALUE: 'totalValuePreviousPercent',
      IMPORT_VALUE: 'importValuePreviousPercent',
      EXPORT_VALUE: 'exportValuePreviousPercent',
      EXPORT_NON_ENERGY_VALUE: 'exportNonEnergyValuePreviousPercent',
      BALANCE: 'balancePreviousPercent',
    },
    previousValue: {
      BALANCE: 'balancePreviousValue',
    },
    value: {
      TOTAL_VALUE: 'totalValue',
      IMPORT_VALUE: 'importValue',
      EXPORT_VALUE: 'exportValue',
      EXPORT_NON_ENERGY_VALUE: 'exportNonEnergyValue',
      BALANCE: 'balance',
    },
  },
};
